const LETTER_A = [
  [ 0, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 0, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_A2 = [
  [ 0, 0, 0, 1, 1, 1, 0 ],
  [ 0, 0, 1, 1, 0, 0, 0 ],
  [ 0, 1, 0, 1, 0, 0, 0 ],
  [ 0, 0, 1, 1, 0, 0, 0 ],
  [ 0, 0, 0, 1, 1, 1, 0 ],
];

const LETTER_a = [
  [ 0, 1, 0, 0, 1, 0, 0 ],
  [ 0, 1, 0, 1, 0, 1, 0 ],
  [ 0, 1, 0, 1, 0, 1, 0 ],
  [ 0, 0, 1, 1, 1, 1, 0 ],
];

const LETTER_B = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 0, 1, 1, 0, 1, 1, 0 ],
];

const LETTER_b = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 1, 0, 0, 0, 1 ],
  [ 0, 0, 1, 0, 0, 0, 1 ],
  [ 0, 0, 0, 1, 1, 1, 0 ],
];

const LETTER_C = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 0, 1, 0, 0, 0, 1, 0 ],
];

const LETTER_c = [
  [ 0, 0, 1, 1, 1, 0, 0 ],
  [ 0, 1, 0, 0, 0, 1, 0 ],
  [ 0, 1, 0, 0, 0, 1, 0 ],
  [ 0, 0, 1, 0, 1, 0, 0 ],
];

const LETTER_D = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 0, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_D2 = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 0, 1, 0, 0, 0, 1, 0 ],
  [ 0, 1, 0, 0, 0, 1, 0 ],
  [ 0, 0, 1, 1, 1, 0, 0 ],
];

const LETTER_d = [
  [ 0, 0, 0, 1, 1, 1, 0 ],
  [ 0, 0, 1, 0, 0, 0, 1 ],
  [ 0, 0, 1, 0, 0, 0, 1 ],
  [ 1, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_E = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
];

const LETTER_e = [
  [ 0, 0, 1, 1, 1, 0, 0 ],
  [ 0, 1, 0, 1, 0, 1, 0 ],
  [ 0, 1, 0, 1, 0, 1, 0 ],
  [ 0, 0, 1, 1, 0, 1, 0 ],
];

const LETTER_e2 = [
  [ 0, 0, 2, 2, 2, 0, 0 ],
  [ 0, 2, 0, 2, 0, 2, 0 ],
  [ 0, 2, 0, 2, 0, 2, 0 ],
  [ 0, 0, 2, 2, 0, 2, 0 ],
];

const LETTER_F = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
];

const LETTER_f = [
  [ 0, 0, 1, 0, 0, 0, 0 ],
  [ 0, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 1, 0, 0, 0, 0 ],
  [ 1, 0, 1, 0, 0, 0, 0 ],
];

const LETTER_G = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 1, 0, 1 ],
  [ 0, 1, 0, 0, 1, 1, 0 ],
];

const LETTER_g = [
  [ 0, 1, 1, 1, 0, 0, 1 ],
  [ 1, 0, 0, 0, 1, 0, 1 ],
  [ 1, 0, 0, 0, 1, 0, 1 ],
  [ 1, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_H = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 1, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_h = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 1, 0, 0, 0, 0 ],
  [ 0, 0, 1, 0, 0, 0, 0 ],
  [ 0, 0, 0, 1, 1, 1, 1 ],
];

const LETTER_I = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_I2 = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 0, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_i = [
  [ 0, 1, 0, 1, 1, 1, 0 ],
];

const LETTER_J = [
  [ 0, 0, 0, 0, 0, 1, 0 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 1, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_j = [
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 1, 1, 1, 1, 0 ],
];

const LETTER_K = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 0, 1, 0, 1, 0, 0 ],
  [ 1, 1, 0, 0, 0, 1, 1 ],
];

const LETTER_K2 = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 0, 1, 0, 1, 0, 0 ],
  [ 0, 1, 0, 0, 0, 1, 0 ],
];

const LETTER_k = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
  [ 0, 0, 1, 1, 0, 1, 1 ],
];

const LETTER_L = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
];

const LETTER_l = [
  [ 1, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_M = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
  [ 0, 0, 1, 0, 0, 0, 0 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
  [ 1, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_m = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
  [ 0, 0, 1, 1, 1, 1, 0 ],
];

const LETTER_N = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 1, 0, 0, 0, 0 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
  [ 1, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_N2 = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 0, 0, 1, 0, 0, 0, 0 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
  [ 0, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_n = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
  [ 0, 0, 1, 1, 1, 1, 0 ],
];

const LETTER_O = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 0, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_o = [
  [ 0, 0, 1, 1, 1, 0, 0 ],
  [ 0, 1, 0, 0, 0, 1, 0 ],
  [ 0, 1, 0, 0, 0, 1, 0 ],
  [ 0, 0, 1, 1, 1, 0, 0 ],
];

const LETTER_P = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 0, 1, 1, 0, 0, 0, 0 ],
];

const LETTER_p = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 0, 0, 1, 0, 0 ],
  [ 1, 0, 0, 0, 1, 0, 0 ],
  [ 0, 1, 1, 1, 0, 0, 0 ],
];

const LETTER_Q = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 1, 1 ],
  [ 0, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_q = [
  [ 0, 1, 1, 1, 0, 0, 0 ],
  [ 1, 0, 0, 0, 1, 0, 0 ],
  [ 1, 0, 0, 0, 1, 0, 0 ],
  [ 1, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_R = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 1, 0, 0, 1, 1, 0, 0 ],
  [ 1, 0, 0, 1, 0, 1, 0 ],
  [ 0, 1, 1, 0, 0, 0, 1 ],
];

const LETTER_r = [
  [ 0, 0, 1, 1, 1, 1, 0 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
  [ 0, 1, 0, 0, 0, 0, 0 ],
];

const LETTER_S = [
  [ 0, 1, 1, 0, 0, 1, 0 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 0, 1, 0, 0, 1, 1, 0 ],
];

const LETTER_S2 = [
  [ 0, 0, 1, 0, 0, 1, 0 ],
  [ 0, 1, 0, 1, 0, 1, 0 ],
  [ 0, 1, 0, 1, 0, 1, 0 ],
  [ 0, 1, 0, 0, 1, 0, 0 ],
];

const LETTER_s = [
  [ 0, 0, 1, 0, 0, 1, 0 ],
  [ 0, 1, 0, 1, 0, 1, 0 ],
  [ 0, 1, 0, 1, 0, 1, 0 ],
  [ 0, 1, 0, 0, 1, 0, 0 ],
];

const LETTER_T = [
  [ 1, 0, 0, 0, 0, 0, 0 ],
  [ 1, 0, 0, 0, 0, 0, 0 ],
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 1, 0, 0, 0, 0, 0, 0 ],
  [ 1, 0, 0, 0, 0, 0, 0 ],
];

const LETTER_t = [
  [ 0, 0, 1, 0, 0, 0, 0 ],
  [ 1, 1, 1, 1, 1, 1, 0 ],
  [ 0, 0, 1, 0, 0, 0, 1 ],
  [ 0, 0, 1, 0, 0, 0, 1 ],
];

const LETTER_U = [
  [ 1, 1, 1, 1, 1, 1, 0 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 1, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_U2 = [
  [ 0, 4, 4, 4, 4, 0, 0 ],
  [ 0, 0, 0, 0, 0, 4, 0 ],
  [ 0, 0, 0, 0, 0, 4, 0 ],
  [ 0, 0, 0, 0, 0, 4, 0 ],
  [ 0, 4, 4, 4, 4, 0, 0 ],
];

const LETTER_u = [
  [ 0, 1, 1, 1, 1, 0, 0 ],
  [ 0, 0, 0, 0, 0, 1, 0 ],
  [ 0, 0, 0, 0, 0, 1, 0 ],
  [ 0, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_V = [
  [ 1, 1, 1, 1, 1, 0, 0 ],
  [ 0, 0, 0, 0, 0, 1, 0 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
  [ 0, 0, 0, 0, 0, 1, 0 ],
  [ 1, 1, 1, 1, 1, 0, 0 ],
];

const LETTER_v = [
  [ 0, 1, 1, 1, 0, 0, 0 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
  [ 0, 0, 0, 0, 0, 1, 0 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
  [ 0, 1, 1, 1, 0, 0, 0 ],
];

const LETTER_v2 = [
  [ 0, 3, 3, 3, 0, 0, 0 ],
  [ 0, 0, 0, 0, 3, 0, 0 ],
  [ 0, 0, 0, 0, 0, 3, 0 ],
  [ 0, 0, 0, 0, 3, 0, 0 ],
  [ 0, 3, 3, 3, 0, 0, 0 ],
];

const LETTER_W = [
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 0, 0, 0, 1, 0 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
  [ 0, 0, 0, 0, 0, 1, 0 ],
  [ 1, 1, 1, 1, 1, 1, 1 ],
];

const LETTER_w = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
  [ 0, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_X = [
  [ 1, 1, 0, 0, 0, 1, 1 ],
  [ 0, 0, 1, 0, 1, 0, 0 ],
  [ 0, 0, 1, 0, 1, 0, 0 ],
  [ 0, 0, 1, 0, 1, 0, 0 ],
  [ 1, 1, 0, 0, 0, 1, 1 ],
];

const LETTER_x = [
  [ 0, 1, 1, 0, 1, 1, 0 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 0, 0, 1, 0, 0, 0 ],
  [ 0, 1, 1, 0, 1, 1, 0 ],
];

const LETTER_Y = [
  [ 1, 1, 0, 0, 0, 0, 0 ],
  [ 0, 0, 1, 0, 0, 0, 0 ],
  [ 0, 0, 0, 1, 1, 1, 1 ],
  [ 0, 0, 1, 0, 0, 0, 0 ],
  [ 1, 1, 0, 0, 0, 0, 0 ],
];

const LETTER_y = [
  [ 1, 1, 1, 1, 0, 0, 1 ],
  [ 0, 0, 0, 0, 1, 0, 1 ],
  [ 0, 0, 0, 0, 1, 0, 1 ],
  [ 1, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_Z = [
  [ 1, 0, 0, 0, 0, 1, 1 ],
  [ 1, 0, 0, 0, 1, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 1, 0, 0, 0, 1 ],
  [ 1, 1, 0, 0, 0, 0, 1 ],
];

const LETTER_z = [
  [ 0, 1, 0, 0, 1, 1, 0 ],
  [ 0, 1, 0, 1, 0, 1, 0 ],
  [ 0, 1, 1, 0, 0, 1, 0 ],
  [ 0, 1, 0, 0, 0, 1, 0 ],
];

const LETTER_0 = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 0, 1 ],
  [ 0, 1, 1, 1, 1, 1, 0 ],
];

const LETTER_1 = [
  [ 0, 1, 0, 0, 0, 0, 1 ],
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 0, 0, 0, 0, 1 ],
];

const LETTER_2 = [
  [ 0, 1, 1, 0, 0, 0, 1 ],
  [ 1, 0, 0, 0, 0, 1, 1 ],
  [ 1, 0, 0, 0, 1, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 0, 1, 1, 0, 0, 0, 1 ],
];

const LETTER_3 = [
  [ 0, 1, 0, 0, 0, 1, 0 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 0, 1, 1, 0, 1, 1, 0 ],
];

const LETTER_4 = [
  [ 0, 0, 0, 1, 1, 0, 0 ],
  [ 0, 0, 1, 0, 1, 0, 0 ],
  [ 0, 1, 0, 0, 1, 0, 0 ],
  [ 1, 1, 1, 1, 1, 1, 1 ],
  [ 0, 0, 0, 0, 1, 0, 0 ],
];

const LETTER_5 = [
  [ 1, 1, 1, 0, 0, 1, 0 ],
  [ 1, 0, 1, 0, 0, 0, 1 ],
  [ 1, 0, 1, 0, 0, 0, 1 ],
  [ 1, 0, 1, 0, 0, 0, 1 ],
  [ 1, 0, 0, 1, 1, 1, 0 ],
];

const LETTER_6 = [
  [ 0, 1, 1, 1, 1, 1, 0 ],
  [ 1, 0, 1, 0, 0, 0, 1 ],
  [ 1, 0, 1, 0, 0, 0, 1 ],
  [ 1, 0, 1, 0, 0, 0, 1 ],
  [ 0, 0, 0, 1, 1, 1, 0 ],
];

const LETTER_7 = [
  [ 1, 0, 0, 0, 0, 0, 0 ],
  [ 1, 0, 0, 0, 1, 1, 1 ],
  [ 1, 0, 0, 1, 0, 0, 0 ],
  [ 1, 0, 1, 0, 0, 0, 0 ],
  [ 1, 1, 0, 0, 0, 0, 0 ],
];

const LETTER_8 = [
  [ 0, 1, 1, 0, 1, 1, 0 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 1, 0, 0, 1, 0, 0, 1 ],
  [ 0, 1, 1, 0, 1, 1, 0 ],
];

const LETTER_9 = [
  [ 0, 1, 1, 1, 0, 0, 0 ],
  [ 1, 0, 0, 0, 1, 0, 1 ],
  [ 1, 0, 0, 0, 1, 0, 1 ],
  [ 1, 0, 0, 0, 1, 0, 1 ],
  [ 0, 1, 1, 1, 1, 1, 0 ],
];

const IMG_LOVE = [
  [ 0, 5, 5, 0, 0, 0, 0 ],
  [ 5, 0, 0, 5, 0, 0, 0 ],
  [ 5, 0, 0, 0, 5, 0, 0 ],
  [ 0, 5, 0, 0, 0, 5, 0 ],
  [ 0, 0, 5, 0, 0, 0, 5 ],
  [ 0, 5, 0, 0, 0, 5, 0 ],
  [ 5, 0, 0, 0, 5, 0, 0 ],
  [ 5, 0, 0, 5, 0, 0, 0 ],
  [ 0, 5, 5, 0, 0, 0, 0 ],
];

const EMPTY_WEEK = [
  [ 0, 0, 0, 0, 0, 0, 0 ]
];

export {
  LETTER_A, LETTER_a,
  LETTER_B, LETTER_b,
  LETTER_C, LETTER_c,
  LETTER_D, LETTER_d,
  LETTER_E, LETTER_e,
  LETTER_F, LETTER_f,
  LETTER_G, LETTER_g,
  LETTER_H, LETTER_h,
  LETTER_I, LETTER_i,
  LETTER_J, LETTER_j,
  LETTER_K, LETTER_k,
  LETTER_L, LETTER_l,
  LETTER_M, LETTER_m,
  LETTER_N, LETTER_n,
  LETTER_O, LETTER_o,
  LETTER_P, LETTER_p,
  LETTER_Q, LETTER_q,
  LETTER_R, LETTER_r,
  LETTER_S, LETTER_s,
  LETTER_T, LETTER_t,
  LETTER_U, LETTER_u,
  LETTER_V, LETTER_v,
  LETTER_W, LETTER_w,
  LETTER_X, LETTER_x,
  LETTER_Y, LETTER_y,
  LETTER_Z, LETTER_z,
  LETTER_0, LETTER_1,
  LETTER_2, LETTER_3,
  LETTER_4, LETTER_5,
  LETTER_6, LETTER_7,
  LETTER_8, LETTER_9,
  IMG_LOVE, EMPTY_WEEK,
};